// @flow
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';
import theme from '../../../theme-config';
import { Icon, ItemsPickerButton } from '../../../components/common';

type Props = {
  isLoading?: boolean,
  label: string,
  onPress?: Function,
};

class ContractsItemsPickerButton extends Component<Props> {
  renderArrow() {
    return <Icon name="arrow-right" size={18} style={styles.arrowStyle} />;
  }

  render() {
    return <ItemsPickerButton {...this.props} labelStyle={styles.labelText} renderArrow={this.renderArrow} />;
  }
}

const styles = StyleSheet.create({
  arrowStyle: {
    color: theme.contracts.arrowColor,
  },
  labelText: {
    fontWeight: 'normal',
    color: theme.contracts.textColor,
  },
});

export default ContractsItemsPickerButton;
